import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Warm up the Supabase connection immediately on module load.
 * Free-tier projects pause after inactivity — the first request
 * can take 10-30s to wake the DB. This fires as early as possible
 * (landing page load) so the DB is already awake when the user
 * navigates to the tutor.
 *
 * The promise is exported so consumers can await it if needed.
 */
export const dbReady: Promise<boolean> = Promise.resolve(
  supabase
    .from("questions")
    .select("id", { count: "exact", head: true })
    .limit(1),
)
  .then(() => true)
  .catch(() => false);
